import React, { useState } from 'react';
import cn from 'classnames';
import dayjs from 'dayjs';
import startCase from 'lodash/startCase';
import PropTypes from 'prop-types';
import Select from '../Select';
import Image from 'components/Image';
import TextInput from '../TextInput';
import DatePicker from 'components/DatePicker';
import iconAdd from 'images/icon_add_item.svg';
import iconTrash from 'images/icon_trash.svg';
import styles from './index.module.scss';

const MultiOptions = ({ optionTypes, label, keys, size, onChange, value }) => {
  const [temp, setTemp] = useState(keys);

  const onAdd = () => {
    const newState = [...value];
    newState.push({
      id: dayjs().toISOString(),
      ...temp,
    });
    setTemp(keys);
    onChange(newState);
  };

  const onRemove = id => {
    let newState = [...value];
    newState = newState.filter(item => item.id !== id);
    onChange(newState);
  };

  const handleChange = e => {
    setTemp({
      ...temp,
      [e.target.name]: e.target.value,
    });
  };

  const updateTime = (field, date) => {
    setTemp({
      ...temp,
      [field]: dayjs(date).toISOString(),
    });
  };

  return (
    <div className={styles.multioptions}>
      <p className={styles.label}>{label}</p>
      <section className={styles.selectionSection}>
        <div className={styles.multiopt}>
          {optionTypes.map((item, key) => {
            switch (item.type) {
              case 'text':
                return (
                  <TextInput
                    id={key}
                    key={key}
                    label={startCase(item.field)}
                    className={cn(styles.input, styles[size])}
                    field={item.field}
                    value={temp[item.field]}
                    onChange={handleChange}
                    placeholder={'Some docs'}
                  />
                );

              case 'select':
                return (
                  <Select
                    key={key}
                    name={item.field}
                    label={startCase(item.field)}
                    className={cn(styles.input, styles[size])}
                    options={item.options}
                    value={temp[item.field]}
                    onChange={handleChange}
                    error={false}
                  />
                );

              case 'date-picker':
                return (
                  <DatePicker
                    key={key}
                    className={styles.datepicker}
                    onChange={date => updateTime(item.field, date)}
                    label={startCase(item.field)}
                    value={temp[item.field]}
                  />
                );
              default:
                return null;
            }
          })}
        </div>
        <Image type="button" src={iconAdd} onClick={onAdd} />
      </section>

      {value.map((vl, k1) => {
        const keys = Object.keys(vl).filter(key => key !== 'id');
        return (
          <section className={styles.display} key={k1}>
            <div className={styles.items}>
              {keys.map((key, k2) => (
                <div className={cn(styles.item, styles[size])} key={k2}>
                  {dayjs(vl[key]).isValid()
                    ? dayjs(vl[key]).format('DD/MM/YYYY')
                    : vl[key]}
                </div>
              ))}
            </div>
            <Image src={iconTrash} onClick={() => onRemove(vl.id)} />
          </section>
        );
      })}
    </div>
  );
};

MultiOptions.propTypes = {
  keys: PropTypes.array,
  size: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.array,
  className: PropTypes.string,
  optionTypes: PropTypes.arrayOf(PropTypes.object),
  label: PropTypes.string,
};

export default MultiOptions;
